import { Component, OnInit, OnChanges, SimpleChanges, Input, EventEmitter, Output } from '@angular/core';
import { ApplicantDataService } from 'src/app/services/applicant-data.service';
import { ArgyleViewBag, ArgyleViewBagResponse, ArgyleStatusExplanation, AdditionalIncomeSource, InviteCreateRequest, AdditionalIncomeSourceType, ArgyleInviteSent, ArgyleIncomeStream } from 'src/app/models/Argyle';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IncomeSourceModalComponent } from 'src/app/shared-components-module/income-source-modal/income-source-modal.component';
import { take, tap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { IncomeSourceGroupsModalComponent } from 'src/app/shared-components-module/income-source-groups-modal/income-source-groups-modal.component';
import { ScreeningLight , Screening} from 'src/app/models/screeningInvite';
import { AuthService } from 'src/app/services/auth.service';
import { FilteringService } from 'src/app/services/filtering.service';
import { RiqAlertComponent } from 'src/app/shared-components-module/riq-alert/riq-alert.component';
import { ArgylePayrollSyncModalComponent } from 'src/app/shared-components-module/argyle-payroll-sync-modal/argyle-payroll-sync-modal.component';
import { ScreeningService } from '../../services/screening.service';
import { IncomeWizardComponent } from '../../income-wizard/income-wizard.component';
import { WizardWorkflowState, DraftIncomeSource, isWizardComplete, normalizeWizardState } from 'src/app/models/income-wizard-workflow';

@Component({
  selector: 'app-argyle',
  templateUrl: './argyle.component.html',
  styleUrls: ['./argyle.component.less']
})
export class ArgyleComponent implements OnInit, OnChanges {
  constructor(public appdata: ApplicantDataService,private modalService: NgbModal, public toast: ToastrService, public auth : AuthService, public filtering: FilteringService, public scrns : ScreeningService){}
  @Input() public screening : ScreeningLight;
  @Output() public hasUnverifiedIncome : EventEmitter<boolean> = new EventEmitter<boolean>();
  baggy : ArgyleViewBagResponse;
  // showSendVerButton : boolean = false;
  incomeSources : AdditionalIncomeSource[] = []
  inviteFailure: any = null;
  wizardState: WizardWorkflowState | null = null;
  wizardStateLoading = false;
  propertyWizardEnabled = false;
  propertyEnabledDate: string | null = null;
  wizardDrafts: DraftIncomeSource[] = [];
  status_explanations : ArgyleStatusExplanation[] = [
    { name : 'sent', expl : 'Invite sent successfully.'},
    { name : 'initiated', expl : 'User clicked the invite URL and was successfully able to enter Link, but has not submitted login credentials, uploaded documents, or completed a response form.'},
    { name : 'attempted', expl : 'User submitted login credentials through Link (creating a user ID), but no accounts were successfully connected. Also includes users who only submitted a response form.'},
    { name : 'completed', expl : 'User successfully connected an account or uploaded a document.'},
    { name : 'revoked', expl : ' The invite was revoked. The user can no longer access Link via the invite URL.'},
  ]
  
 

public get showSendVerButton() : boolean {
  return this.auth.UserInRole('CRA') && this.showLogs && this.auth.UserInRole('IncomeVerSender') && !this.baggy.argyleInvite.inviteRevoked;

}

  // IncomeMgr keeps the existing manager button; SendNewIncomeVer is CS/IA-only (no readiness override / stranded close).
  public get canSendNewIncomeVer(): boolean {
    return this.auth.UserInRole('IncomeMgr') || this.auth.UserInRole('SendNewIncomeVer');
  }


 public get showLogs() : boolean {
   return this.baggy && this.baggy.argyleInvite && this.baggy.sentLogs.length > 0;
 }

 
  public get onlyHasWorkNumber()  : boolean {
   return this.baggy && this.baggy.argyleInvite && this.baggy.argyleInvite.inviteRevoked && this.baggy?.streams.length > 0 && this.baggy?.streams.filter(sr=>{return sr.streamType == 3;}).length == this.baggy?.streams.length;
 }
 
 
  
  public get applicantName() : string {
    return `- ${this.screening.applicantFirstName} ${this.screening.applicantLastName}`;
  }

  public get hasErrorStreams(): boolean {
    return this.baggy?.streams?.some(s => s.hasDataErrors) ?? false;
  }
  

  public get inviteStatusTitle() : string {
    if(this.baggy.argyleInvite)
    {
      let exp = this.status_explanations.find(st=> {return st.name == this.baggy.argyleInvite.status});
      return exp?.expl;
    }
    return 'No status data available for this invite'
  }
 
  get incomeWizardUser(): boolean {
    return this.auth.UserInRole('IncomeWizardUser') && this.propertyWizardEnabled && !this.showLegacyIncome;
  }

  // Show legacy when property not enabled, or when screening predates property enablement
  get showLegacyIncome(): boolean {
    if (!this.propertyWizardEnabled) return true;
    if (this.propertyEnabledDate && new Date(this.screening.invitationDate) < new Date(this.propertyEnabledDate)) return true;
    return false;
  }

  get incomeWizardComplete(): boolean {
    return isWizardComplete(this.wizardState);
  }

  get isIncomeAuditor(): boolean {
    return this.auth.UserInRole('IncomeAuditor');
  }

  get canAudit(): boolean {
    return this.isIncomeAuditor && this.incomeWizardComplete;
  }

  get incomeWizardButtonLabel(): string {
    if (this.incomeWizardComplete) {
      return 'Income Complete ✓';
    }
    return this.wizardState ? 'Resume Income' : 'Work Income';
  }

  loadWizardState(): void {
    if (!this.auth.UserInRole('IncomeWizardUser') || !this.screening?.screeningId) {
      return;
    }
    this.wizardStateLoading = true;

    // Check property enablement first
    this.appdata.isWizardEnabledForProperty(this.screening.locationId).subscribe({
      next: (res) => {
        this.propertyWizardEnabled =  res?.enabled ?? false;
        this.propertyEnabledDate = res?.enabledDate ?? null;
        if (!this.propertyWizardEnabled) {
          this.wizardStateLoading = false;
          return;
        }
        // Property enabled — load wizard state
        this.appdata.getWizardState(this.screening.screeningId).subscribe({
          next: (state) => {
            this.wizardState = normalizeWizardState(state);
            this.wizardStateLoading = false;
            if (this.incomeWizardComplete) {
              this.loadWizardDrafts();
            }
          },
          error: (err) => {
            if (err.status === 404) {
              this.wizardState = null;
            }
            this.wizardStateLoading = false;
          },
        });
      },
      error: () => {
        this.propertyWizardEnabled = false;
        this.wizardStateLoading = false;
      },
    });
  }

  loadWizardDrafts(): void {
    this.appdata.getWizardDraftSources(this.screening.screeningId).subscribe({
      next: (drafts) => { this.wizardDrafts = drafts ?? []; },
      error: () => { this.wizardDrafts = []; },
    });
  }

  get includedDrafts(): DraftIncomeSource[] {
    return this.wizardDrafts.filter((d) => !d.isExcluded);
  }

  get excludedDrafts(): DraftIncomeSource[] {
    return this.wizardDrafts.filter((d) => d.isExcluded);
  }

  get totalIncludedMonthly(): number {
    return this.includedDrafts.reduce((sum, d) => sum + d.incomeAmount, 0);
  }

  // Opens income verification wizard modal.
  openIncomeWizard(): void {
    if (this.incomeWizardComplete) {
      return;
    }
    this.openWizardModal(false);
  }

  forceEnableWizard(): void {
    this.propertyWizardEnabled = true;
    this.propertyEnabledDate = null;
    this.wizardStateLoading = true;
    this.appdata.getWizardState(this.screening.screeningId).subscribe({
      next: (state) => {
        this.wizardState = normalizeWizardState(state);
        this.wizardStateLoading = false;
        if (this.incomeWizardComplete) {
          this.loadWizardDrafts();
        }
      },
      error: (err) => {
        if (err.status === 404) {
          this.wizardState = null;
        }
        this.wizardStateLoading = false;
      },
    });
  }

  // Opens wizard in audit review mode (read + edit + flag).
  openAuditReview(): void {
    if (!this.canAudit) {
      return;
    }
    this.openWizardModal(true);
  }

  private openWizardModal(auditMode: boolean): void {
    const ref = this.modalService.open(IncomeWizardComponent, {
      centered: true,
      size: 'lg',
      backdrop: 'static',
      keyboard: false,
    });
    ref.componentInstance.screeningId = this.screening.screeningId;
    ref.componentInstance.argyleBag = this.baggy;
    ref.componentInstance.auditMode = auditMode;
    ref.result.then(
      (result) => {
        this.loadWizardState();
        if (result === 'complete') {
          this.loadSources();
          this.loadWizardDrafts();
        } else if (!auditMode) {
          this.toast.info('Progress saved — you can resume later.');
        }
      },
      () => {
        this.loadWizardState();
        if (!auditMode) {
          this.toast.info('Progress saved — you can resume later.');
        }
      }
    );
  }

  manageGroupIncome(){
    const modalRef = this.modalService.open(IncomeSourceGroupsModalComponent, { centered: true, size: 'xl' })
    modalRef.componentInstance.name = 'IncomeSourceGroupsModalComponent';   
    modalRef.componentInstance.screening = this.screening;
    modalRef.componentInstance.sourceTypes = this.appdata.incomeSourceTypes; 
    // modalRef.componentInstance.newSource = src;
    modalRef.componentInstance.saved.subscribe((dta: boolean)=>{
      this.loadSources();
    })
  }

   addSource() {
    const modalRef1 = this.modalService.open(IncomeSourceModalComponent, { centered: true, size: 'lg' })
    modalRef1.componentInstance.name = 'IncomeSourceModalComponent';
    modalRef1.componentInstance.screeningId = this.screening.id;
    modalRef1.componentInstance.applicantName = `- ${this.screening.applicantFirstName} ${this.screening.applicantLastName}`;
    modalRef1.componentInstance.showSnapptToggle = this.screening.billingRule;
    modalRef1.componentInstance.sourceTypes = this.appdata.incomeSourceTypes;
    // if(src != null)this.modalRef1.componentInstance.newSource = src;
    modalRef1.componentInstance.saved.subscribe((dta: boolean) => {
      this.loadSources();
      this.modalService.dismissAll();
    })
    modalRef1.componentInstance.closed.subscribe((dta: boolean) => {
      this.modalService.dismissAll();
    })
  }

  mapToSource(i : ArgyleViewBag){
    console.log('adding new income source', i);
    let src = new AdditionalIncomeSource();
    src.amount = i.summary.monthlyGrossAverage;
    src.incomeType = AdditionalIncomeSourceType.currentEmployment;
    src.incomeSourceDescription = `${i.identityData.employer}(${i.identityData.employment_status} employment) verified via payroll sync`;
    src.incomeVerified = i.identityData.employment_status == 'active';

    const modalRef1 = this.modalService.open(IncomeSourceModalComponent, { centered: true, size: 'lg' })
    modalRef1.componentInstance.name = 'IncomeSourceModalComponent';
    modalRef1.componentInstance.screeningId = this.screening.id;
    modalRef1.componentInstance.applicantName = `- ${this.screening.applicantFirstName} ${this.screening.applicantLastName}`;
    modalRef1.componentInstance.showSnapptToggle = this.screening.billingRule;
    modalRef1.componentInstance.sourceTypes = this.appdata.incomeSourceTypes;
    modalRef1.componentInstance.newSource = src;
    modalRef1.componentInstance.addingFromVerified = true;
    // if(src != null)this.modalRef1.componentInstance.newSource = src;
    modalRef1.componentInstance.saved.subscribe((dta: boolean) => {
      this.loadSources();
      this.modalService.dismissAll();
    })
    modalRef1.componentInstance.closed.subscribe((dta: boolean) => {
      this.modalService.dismissAll();
    })
    
  }

  refireInvite(){
      const modalRef = this.modalService.open(RiqAlertComponent, { centered: true, size: 'lg' });
    modalRef.componentInstance.name = 'ConfirmResend';
    modalRef.componentInstance.title = "Confirm Income Resend";
    modalRef.componentInstance.confirmButtonText = `Send New Income Ver to Applicant`;
    modalRef.componentInstance.cancelButtonText = "Cancel";
    modalRef.componentInstance.alertBody = `This action will send an entirely new income verification to the applicant, are you sure?`
    modalRef.componentInstance.checkboxLabel = "Send New WorkNumber also?";
    modalRef.componentInstance.evnt.subscribe((ev:boolean)=>{
      const skipTWN = !modalRef.componentInstance.checkboxChecked;
      this.scrns.GetScreeningById(this.screening.id,true).pipe(take(1),tap((scr: Screening)=>{})).subscribe(scr=>{
        this.appdata.ReprocessArgyleInvite(scr, this.screening.invitationId, skipTWN).subscribe(()=>{
          this.toast.success('New Income Ver Has Been Sent to Applicant');
          modalRef.dismiss();
        })
        },()=>{
          this.toast.error('Error sending new income ver');
        });
      // this.reportReleasing = true;

    });
  }

  reSendVer(){
    const modalRef = this.modalService.open(RiqAlertComponent, { centered: true, size: 'lg' });
    modalRef.componentInstance.name = 'ConfirmResend';
    modalRef.componentInstance.title = "Confirm Income Resend";
    modalRef.componentInstance.confirmButtonText = `Send Income Ver to Applicant`;
    modalRef.componentInstance.cancelButtonText = "Cancel";
    modalRef.componentInstance.alertBody = `This action will send the income verification invite to the last logged email/phone, are you sure?`
    modalRef.componentInstance.evnt.subscribe((ev:boolean)=>{
      // this.reportReleasing = true;
      let sendMe = this.baggy.argyleInvite.inviteSentLogs[0];
      this.appdata.ResendArgyleInvite(sendMe).subscribe(()=>{
        this.toast.success('invite resend success');
        this.loadIncomeVer();
      },
      ()=>{
        this.toast.error('This invitation has been revoked and cannot be resent to the applicant.', 'Invite send Error');
      }, ()=>{

        modalRef.dismiss();
      })}
    );
   }


  sendVer(){
    let crte = new InviteCreateRequest();
    crte.firstName = this.screening.applicantFirstName;
    crte.lastName = this.screening.applicantLastName;
    crte.email = this.screening.applicantEmail;
    crte.locationId = this.screening.locationId;
    crte.screeningId = this.screening.screeningId;
    crte.locationName = this.screening.locationName;
    crte.docsOnly = false; // only for debugging
    this.appdata.FireArgyleInviteInternal(crte).pipe(tap(_=>{
      console.warn(_);
      this.toast.success('Income verification sent!', 'Succes!');
    },()=>{
      this.toast.error('Error sending invite to applicant')
    })).subscribe();
  }

  ngOnInit(): void {
    console.warn(this.screening);
    this.loadIncomeVer();
    this.loadSources();
    this.loadWizardState();
    this.loadInviteFailure();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const c = changes['screening'];
    if (!c || !this.screening?.screeningId) {
      return;
    }
    if (c.firstChange) {
      this.loadWizardState();
      return;
    }
    const prev = c.previousValue as ScreeningLight | undefined;
    if (prev && prev.id === this.screening.id && prev.screeningId === this.screening.screeningId) {
      return;
    }
    this.loadIncomeVer();
    this.loadSources();
    this.loadWizardState();
    this.loadInviteFailure();
  }

  loadInviteFailure(): void {
    if (!this.screening?.screeningId) return;
    this.appdata.GetInviteFailure(this.screening.screeningId).subscribe({
      next: (f) => { this.inviteFailure = f; },
      error: () => { this.inviteFailure = null; },
    });
  }

  resolveInviteFailure(): void {
    if (!this.screening?.screeningId) return;
    this.appdata.ResolveInviteFailure(this.screening.screeningId).subscribe({
      next: () => {
        this.inviteFailure = null;
        this.toast.success('Income verification completed without income data.');
        this.loadIncomeVer();
      },
      error: () => { this.toast.error('Failed to resolve invite failure.'); },
    });
  }

  //note, this specifically handles when an existing source is UPDATED to be verified/unverified
  handleUnverIncome(event: boolean) 
  {
    console.log('handling unver income in argyle component', event);
    this.hasUnverifiedIncome.emit(event);
  }

  loadIncomeVer(){
    this.appdata.GetArgyleDataForReport(this.screening.screeningId).subscribe((ar: ArgyleViewBagResponse)=>{
      this.baggy = new ArgyleViewBagResponse();
      this.baggy.argyleInvite = ar?.argyleInvite;
      this.baggy.streams = [];
      this.baggy.sentLogs = ar?.sentLogs;
      ar.streams.forEach(bg =>{
        bg.screeningId = this.screening.screeningId;
        this.baggy.streams.push(Object.assign(new ArgyleIncomeStream(),bg));
      })
      this.screening.argyleData = this.baggy;
      // if(!this.baggy && this.auth.UserInRole('IncomeVerSender')) this.showSendVerButton = true;
      // console.log(this.baggy)
    });
  }

  public loadSources(){
    this.appdata.GetAdditionalIncomeSources(this.screening.screeningId).pipe(take(1),tap((_: AdditionalIncomeSource[])=>{
      this.incomeSources = _;
      if(this.incomeSources.some(src => !src.incomeVerified)) {
        this.hasUnverifiedIncome.emit(true);
      } else this.hasUnverifiedIncome.emit(false);
    })).subscribe();
  }

  public refreshSource(stream : ArgyleIncomeStream)
  {
    this.appdata.RefreshIncomeStream(this.screening.screeningId,stream.streamType).subscribe((str: ArgyleIncomeStream)=>{
      this.toast.success('Stream refreshed from vendor');
      this.loadIncomeVer();
    }, () => {
      this.toast.error('Failed to refresh stream - try again or escalate');
    })
  }

  public reviewSource(stream : ArgyleIncomeStream){
    const modalRef = this.modalService.open(ArgylePayrollSyncModalComponent, { centered: true, size: 'lg' });
    modalRef.componentInstance.stream = stream;
    modalRef.componentInstance.saved.subscribe((dta: boolean) => {
      this.loadSources()
      modalRef.dismiss();
    })
  }
}
